module.exports = __webpack_public_path__ + "static/media/S (175).465fbf4b.jpg";